import { WIDGET_ROOT_ID } from '@/helpers/constants';
import { createShadowRoot } from '@/helpers/functions/shadowDom';
import { injectStylesIntoShadow } from '@/helpers/functions/shadowStyles';
import { renderWidget, unmountWidget } from '@/helpers/functions/widgetRender';
import { platformHandlers } from '@/platforms';
import type { I_Widget, I_WidgetConfig } from '@/types/Widget';
import { E_WidgetPlatform } from '@/types/Widget';

class Widget implements I_Widget {
  private rootId = WIDGET_ROOT_ID;
  private root: HTMLElement | null = null;
  private shadowRoot: ShadowRoot | null = null;
  private widgetRoot: HTMLElement | null = null;

  mount(querySelector: string, config: I_WidgetConfig): void {
    if (this.root) {
      console.warn('EnableWidget is already mounted');
      return;
    }

    const element = document.querySelector(querySelector);
    if (!element) throw new Error(`Element with querySelector ${querySelector} not found`);

    const platformHandler = platformHandlers[config.platform ?? E_WidgetPlatform.SHOPIFY];
    platformHandler.setup?.(config.buyNowButtonSelector);

    const { host, shadowRoot, widgetRoot } = createShadowRoot(this.rootId);

    element.appendChild(host);
    this.root = host;
    this.shadowRoot = shadowRoot;
    this.widgetRoot = widgetRoot;

    injectStylesIntoShadow({ shadowRoot, rootId: this.rootId });
    renderWidget(widgetRoot, platformHandler, config);
  }

  unmount(): void {
    if (!this.root || !this.widgetRoot) return;

    unmountWidget(this.widgetRoot);
    this.root.remove();
    this.root = null;
    this.shadowRoot = null;
    this.widgetRoot = null;
  }
}

export { Widget };
export type { I_WidgetConfig };

if (typeof window !== 'undefined') {
  window.EnableWidget = Widget;
}
